module.exports = __webpack_public_path__ + "static/media/Scarcity Effect.e289c950.jpg";